import React, { PureComponent } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { rescheduleOverload } from 'features/todolist/store/actions'
import { openPopup, closePopup } from 'features/popup/store/actions'
import { styles, translations } from 'gipsy-misc'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      openPopup,
      rescheduleOverload,
      closePopup
    },
    dispatch
  )
})

const Button = styled.div`
  background-color: ${styles.colors.lightPink};
  border-radius: 14px;
  font-size: ${styles.spacings.small};
  line-height: ${styles.spacings.small};
  margin-right: 7px;
  padding: 10px 10px;
  color: ${styles.colors.pinkColor};
  cursor: pointer;
  transition: background-color 300ms linear;
  & > span {
    display: inline-block;
    vertical-align: middle;
  }
  .text {
    position: relative;
    top: -1px;
    transition: opacity 300ms linear;
  }
  .dot {
    width: ${styles.spacings.xsmall};
    height: ${styles.spacings.xsmall};
    background-color: ${styles.colors.pinkColor};
    border-radius: 50%;
    margin-left: 6px;
  }
  &:hover {
    filter: brightness(105%);
  }
`

class RescheduleOverloadButton extends PureComponent {
  openPopup = () => {
    this.props.actions.openPopup({
      title: translations.rescheduleOverload.popup.title,
      message: translations.rescheduleOverload.popup.message,
      button: translations.rescheduleOverload.popup.button,
      action: this.rescheduleOverload
    })
  }

  rescheduleOverload = () => {
    this.props.actions.rescheduleOverload()
    this.props.actions.closePopup()
  }

  render() {
    return (
      <Button onClick={this.openPopup}>
        <span className="text">{translations.rescheduleOverload.button}</span>
        <span className="dot" />
      </Button>
    )
  }
}

export default connect(
  null,
  mapDispatchToProps,
  null,
  {
    pure: true
  }
)(RescheduleOverloadButton)



// WEBPACK FOOTER //
// ./src/features/todolist/components/rescheduleOverloadButton/index.js